import React,{useState,useContext,useCallback,useRef,useEffect} from 'react';
import AnnotationContext from '../../../../context/annotation/AnnotationContext';
import AIPathology from './AIPathology/AIPathology';
import AddedPathology from './AddedPathology/AddedPathology';
import { TooltipHost } from '@fluentui/react';
import { ScrollMenu, VisibilityContext } from "react-horizontal-scrolling-menu";
import { LeftArrowFunction, RightArrowFunction } from "../../helper/Arrows";
import usePrevious from "../../helper/usePrevious";
import { t } from "i18next";
import ThumbnailContext from '../../../../context/studyviewer/ThumbnailContext';

const NonEditablePathologiesList = () => {

    const {
        allAnnotations,
        addedAnnotation,
        addedChildAnnotation,
        addOrRemoveAnnotation,
        submitSelectedOptions,
        checkForOptionSubOption,
      } = useContext(AnnotationContext);

      const { activeStudyId } = useContext(ThumbnailContext);

      const addedChildAnnotationList = addedChildAnnotation[activeStudyId];

      const [position, setPosition] = useState(100);

      const restorePosition = useCallback(
        ({ scrollContainer }) => {
          if (scrollContainer.current) {
            scrollContainer.current.scrollLeft = position;
          }
        },
        [position]
      );
    
      const savePosition = useCallback(
        ({ scrollContainer }) =>
          !!scrollContainer.current &&
          setPosition(scrollContainer.current.scrollLeft),
        []
      );
    
      function onWheel(apiObj, ev) {
        const isThouchpad = Math.abs(ev.deltaX) !== 0 || Math.abs(ev.deltaY) < 15;
    
        if (isThouchpad) {
          ev.stopPropagation();
          return;
        }
    
        if (ev.deltaY < 0) {
          apiObj.scrollNext();
        } else if (ev.deltaY > 0) {
          apiObj.scrollPrev();
        }
      }

    const apiRef = useRef();
    const itemsPrev = usePrevious(addedChildAnnotationList);
      useEffect(() => {
        if (addedChildAnnotationList.length > itemsPrev?.length) {
          apiRef.current?.scrollToItem?.(
            apiRef.current?.getItemElementById(addedChildAnnotationList.slice(-1)?.[0]?.id)
          );
        }
      }, [addedChildAnnotation, itemsPrev]);

    return (<>
        {addedChildAnnotationList != undefined && addedChildAnnotationList.length > 0 && (
          <div className="added-pathology-box">
            <ScrollMenu
              LeftArrow={LeftArrowFunction}
              RightArrow={RightArrowFunction}
              onInit={restorePosition}
              onScroll={savePosition}
              onWheel={onWheel}
              apiRef={apiRef}
            >
              {addedChildAnnotationList != undefined &&
                addedChildAnnotationList.map((annotation, index) => {
                  if (annotation.isActive && (!annotation.ai_predicted || (annotation.ai_predicted && annotation.is_selected))) 
                    {
                      return (
                        <div key={annotation.id}>
                          <NonEditedAITag
                            pathalogyName={annotation.name}
                            backgroundColor={annotation.colour}
                            aiPercent={annotation.corrPathPrediction}
                            showConfigure={
                              false
                            }
                            allData={annotation}
                            showWarning={annotation.is_selected == 1? true: false}
                            addOrRemoveAnnotation={addOrRemoveAnnotation}
                            id={annotation.id}
                            isAI = {annotation.ai_predicted == 1? true: false}
                            isAIEdited = {false}
                            //unSelectAIPathology = {unSelectAIPathology}
                            //changeVisibilityBB = {changeVisibilityBB}
                          />
                        </div>
                      );
                   
                    
                  } 
                  // else if (
                  //   !annotation.is_locked_check &&
                  //   annotation.isActive &&
                  //   annotation.corrPathPrediction > 0
                  // ) {
                  //   return (
                  //     <div key={annotation.id}>
                  //       <AIPathology
                  //         pathalogyName={annotation.name}
                  //         aiPercent={annotation.corrPathPrediction}
                  //         backgroundColor={annotation.color}
                  //       />
                  //     </div>
                  //   );
                  // }
                })}
            </ScrollMenu>
          </div>
        )}
      </>)
}

export default NonEditablePathologiesList;

const NonEditedAITag = (props) => {

    function hexToRgb(hex, check) {
        var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
        if (result != null) {
          var r = parseInt(result[1], 16);
          var g = parseInt(result[2], 16);
          var b = parseInt(result[3], 16);
        }
        if (check) {
          return "rgb(" + r + "," + g + "," + b + ",0.5)";
        }
        return "rgb(" + r + "," + g + "," + b + ")";
      }
    
      const getAbbreviated = (str) => {
        var matches = str.match(/\b(\w)/g);
        var acronym = matches.join("");
        if (acronym.length > 2) {
          acronym = acronym.slice(0, 2);
        }
        return acronym;
      };


    return (<>
      <div
      className="height-manage"
    >
      <div style={{ marginRight: "5px", marginLeft: "20px", marginTop:'5px' }}>
        <div
          className="selected-annotation-box"
          // }}
          style={{
            background: props.backgroundColor,
            border: `1px dashed ${props.backgroundColor}`,
            borderRadius: "8px",
            paddingRight: "10px"
          }}
        >

          {props.isAI && (
            <div
              className="ai-tag"
              style={{
                right: "-10px",
                width:"19px",
              }}
            ><span className="ai-tag-text">{t("annotations.ai")} </span>
            </div>
          )}
              
            
          

          {(
            (props.showWarning) ||
            (props.isAI)
          ) ? (<></>
          ): (<>
          <div
            className="abbre-pathology"
            style={{ background: "rgb(81, 80, 80,0.3", marginRight: "10px",position:'relative',
            // letterSpacing: getAbbreviated(props.pathalogyName).length >=1 ? 1:0
          }}
          >
            {getAbbreviated(props.pathalogyName)}
          </div>
          </>)}

          {((props.showWarning) ||
            (props.isAI)) && (
            <div
              className="abbre-pathology"
              style={{
                marginRight: "10px",
                position: "relative",
                background: !props.showWarning
                  ? "rgba(81, 80, 80, 0.3)"
                  : hexToRgb(props.backgroundColor, true),
                // letterSpacing:
                //   getAbbreviated(props.pathalogyName).length >= 2 ? 1 : 0,
              }}
            >
              {getAbbreviated(props.pathalogyName)}
              {props.isAI && (
                <div className="ai-tag-update-container">
                  <span className="ai-update-text">{props.aiPercent}%</span>
                </div>
              )}
            </div>
          )}
          <div className="pathalogy-name no-margin">{props.pathalogyName}</div>
        </div>
      </div>
    </div>
    </>)
}